import MyDateTime from "../../../DTechComp/MyDateTime";

//מציג את שעות השבוע בקיבוץ ימים עוקבים בעלי אותן שעות,
//למשל "א'-ה' : 09:00-23:00".
//
//יום סגור מזוהה לפי Closed. הטריק הישן של 00:00-00:00 ושעות ריקות
//נשארים כ-fallback לנתונים שלא עברו את migrateHours.
//
//normalizeHM ולא getShortTime, כי getShortTime עובד בשעון הדפדפן
//ומחזיר Invalid date על "HH:mm".
//
//שורה שצדדיה צמודים לעוגן "שעת בסיס" במאסטר (OpenFromMaster וכו')
//נפתרת דרך MyDateTime.resolveRowHM מול props.master. בלי זה שעות
//צמודות-עוגן בלי ערך ידני היו מוצגות ריק / שגוי.
//
//חישוב בזמן render ולא ב-useEffect - זו נגזרת טהורה של ה-props,
//וכך גם נמנע לופ רינדור כשההורה בונה את המערך inline.
const WeekOpeningHours = (props) => {

    const OpenHour = props.OpeningHours;
    const master = props.master;

    if (!Array.isArray(OpenHour) || OpenHour.length === 0) {
        return null;
    }

    const labelOf = (row) => {
        const resolved = MyDateTime.resolveRowHM(row, master);
        const open = MyDateTime.normalizeHM(resolved.Open);
        const close = MyDateTime.normalizeHM(resolved.Close);

        const closed = resolved.Closed === true ||
            open === "" || close === "" ||
            (open === "00:00" && close === "00:00");

        if (closed) return props.noWork;

        //יום עם הפסקה -> "08:00-14:00, 17:00-00:00"
        return MyDateTime.hoursSegments({ Open: open, Close: close, Break: resolved.Break })
            .map(sg => sg[0] + "-" + sg[1]).join(", ");
    }

    const rows = OpenHour.map(r => ({
        letter: MyDateTime.getDayOfWeekLettersHeb(r.Day) + "\'",
        label: labelOf(r)
    }));

    //איחוד ימים עוקבים בעלי אותה תווית
    const groups = [];
    for (let i = 0; i < rows.length; i++) {
        const last = groups[groups.length - 1];
        if (last && last.label === rows[i].label) {
            last.end = rows[i].letter;
        }
        else {
            groups.push({ start: rows[i].letter, end: rows[i].letter, label: rows[i].label });
        }
    }

    return (
        <>
            {groups.map((g, index) => (
                <p className="DDS" key={index}>
                    {(g.start === g.end ? g.start : g.start + "-" + g.end) + " : " + g.label}
                </p>
            ))}
        </>
    )
}

export default WeekOpeningHours;
